import { useCallback, useEffect, useState } from "react";
import {
  DateRangePicker,
  DateRange,
  LocalizationProvider,
  SingleInputDateRangeField,
} from "@mui/x-date-pickers-pro";
import { TextField } from "@mui/material";
import { AdapterMoment } from "@mui/x-date-pickers-pro/AdapterMoment";
import moment from "moment";
import {
  GridFilterItem,
  GridRenderHeaderFilterProps,
  useGridApiContext,
} from "@mui/x-data-grid-pro";

export const DateRangeHeaderArrayFilter = (
  props: GridRenderHeaderFilterProps
) => {
  const { item, inputRef } = props;
  const apiRef = useGridApiContext();

  // Expecting value as [start, end] or null/empty
  const [range, setRange] = useState<DateRange<moment.Moment>>([null, null]);
  useEffect(() => {
    if (item.value && Array.isArray(item.value) && item.value.length === 2) {
      const [startRaw, endRaw] = item.value;
      const start = startRaw ? moment(startRaw) : null;
      const end = endRaw ? moment(endRaw) : null;
      setRange([start, end]);
    } else {
      setRange([null, null]);
    }
  }, [item.value]);

  const applyFilterChanges = useCallback(
    (updatedItem: GridFilterItem) => {
      if (item.value && !updatedItem.value) {
        apiRef.current.deleteFilterItem(updatedItem);
      } else {
        apiRef.current.upsertFilterItem(updatedItem);
      }
    },
    [apiRef, item]
  );

  const [hasError, setHasError] = useState(false);
  const [open, setOpen] = useState(false);

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DateRangePicker
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        value={range}
        onError={(range) => {
          setHasError(range.some((item) => item !== null));
        }}
        onChange={(range) => {
          setRange(range);
          const [start, end] = range;
          setHasError(
            (start !== null && end === null) || (end !== null && start === null)
          );
          if (start?.isValid() && end?.isValid()) {
            applyFilterChanges({
              ...item,
              value: [start.toDate(), end.toDate()],
            });
          }
          // Do not clear the filter if only one date is selected
        }}
        slots={{
          field: SingleInputDateRangeField,
          textField: TextField,
        }}
        inputRef={inputRef as React.MutableRefObject<HTMLInputElement>}
        slotProps={{
          field: {
            clearable: true,
            onClear: () => {
              setRange([null, null]);
            },
          },
          textField: {
            variant: "standard",
            error: hasError && !open,
            sx: {
              marginTop: "16px",
              width: "220px",
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};
